<template>
    <div class="previous-button">
        <button
            type="button"
            v-if="previousStepId"
            @click.prevent="goBack"
            class="btn btn-brand btn-trans"
        >
            <i class="zmdi zmdi-arrow-left mr-3"></i>
            <span>{{ trans('global.back') }}</span>
        </button>
    </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
    props: {
        previousStepId: {
            type: String,
            default: null
        },
    },

    methods: {
        ...mapActions('OnlineBooking', ['setCurrentStep']),
        goBack () {
            this.setCurrentStep(this.previousStepId);
        }
    },
}
</script>

<style scoped>
.previous-button {
    margin-bottom: 0 !important;
}
</style>